.focus {
	outline: none;

	&[data-focus-visible] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}
}

.buttonGroup {
	&[data-orientation='horizontal'] {
		& :where(button, a, label):first-child:not(:only-child) {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}

		& :where(button, a, label):last-child:not(:only-child) {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		& :where(button, a, label):not(:first-child) {
			margin-inline-start: -1px;
		}

		& :where(button, a, label):not(:first-child):not(:last-child) {
			border-radius: 0;
		}
	}

	&[data-orientation='vertical'] {
		& :where(button, a, label):first-child:not(:only-child) {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		& :where(button, a, label):last-child:not(:only-child) {
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}

		& :where(button, a, label):not(:first-child):not([role='separator']) {
			margin-block-start: -1px;
		}

		& :where(button, a, label):not(:first-child):not(:last-child) {
			border-radius: 0;
		}
	}
}

.interactive {
	cursor: pointer;

	&[data-disabled] {
		cursor: not-allowed;
	}
}

.field {
	&:is(input, textarea) {
		cursor: text;
	}

	&[data-disabled] {
		cursor: not-allowed;
	}
}

.selectable {
	&[data-selection-mode],
	&[data-href] {
		cursor: pointer;
	}

	&[data-disabled][data-selection-mode] {
		cursor: not-allowed;
	}
}

:global([data-lp][aria-disabled='true']) {
	opacity: 0.64;
	cursor: default;
}

.invalid {
	border-color: var(--lp-color-border-field-error);
}
